export default __webpack_public_path__ + "static/media/supply_2.63d9b04e.png";